const CHANGE_QUANTITY_STATUS = {
  INCREASE: 'INCREASE',
  REDUCE: 'REDUCE',
};

export default CHANGE_QUANTITY_STATUS;
